import React from "react";
import { Box, MenuItem, Select, Typography } from "@mui/material";
import IconCircle from "../shared/IconCircle";
import SettingsSecondaryButton from "../shared/SettingsSecondaryButton";
import { cardDescSx, cardTitleSx, COLORS, FONT } from "../shared/styles";
import { DEFAULT_SOUND_OPTIONS } from "./constants";
import { ReactComponent as DropdownIcon } from "../../../../assets/images/dropdown-arrow.svg";
import { VolumeIcon } from "./icons";

const selectSx = {
  width: 280,
  height: 40,
  "&:focus": {
    outline: "none",
    borderColor: COLORS.primary,
  },
};

function NotificationSoundCard({
  soundChoice,
  onSoundChange,
  onTestSound,
  soundOptions = DEFAULT_SOUND_OPTIONS,
  disabled = false,
}) {
  return (
    <Box
      sx={{
        mt: "24px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
        minHeight: 137,
        p: "24px",
        borderRadius: "8px",
        border: `1px solid ${COLORS.border}`,
        bgcolor: COLORS.white,
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
        <IconCircle bgcolor={COLORS.backgroundLight}>
          <VolumeIcon />
        </IconCircle>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography component="p" sx={cardTitleSx}>
            Notification Sound
          </Typography>
          <Typography component="p" sx={{ ...cardDescSx, mt: "4px" }}>
            Choose the sound for in-app notifications
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          ml: "64px",
          justifyContent: "space-between",
          "@media (max-width: 720px)": {
            ml: 0,
            width: "100%",
            flexDirection: "column",
            alignItems: "stretch",
          },
        }}
      >
        <Select
          value={soundChoice}
          onChange={(e) => onSoundChange(e.target.value)}
          disabled={disabled}
          IconComponent={DropdownIcon}
          sx={{
            ...selectSx,
            "@media (max-width: 720px)": {
              width: "100%",
            },
          }}
        >
          {soundOptions.map((opt) => (
            <MenuItem key={opt.key} value={opt.key}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
        <SettingsSecondaryButton
          type="button"
          onClick={onTestSound}
          disabled={disabled}
          sx={{
            width: 120,
            flexShrink: 0,
            "@media (max-width: 720px)": {
              width: "100%",
            },
          }}
        >
          Test Sound
        </SettingsSecondaryButton>
      </Box>
    </Box>
  );
}

export default NotificationSoundCard;
